import React from 'react'

export const FirebaseContext = React.createContext(null)

export const FirebaseProvider = ({ value, children }) => {
  return (
    <FirebaseContext.Provider value={value}>{children}</FirebaseContext.Provider>
  )
}
